<template>

  <PrimeDataTable
    :title="'Category'"
    :showFilter="true"
    :searchOption="true"
    :selectAll="true"
    :showDownload="true"
    :showUpload="false"
    :showAdd="true"
    :columnData="columns"
    :data="data"
    @addDiolog="addDiolog()"
    @rowAction="rowActions($event)"
    activity="category"
  />

  <v-dialog persistent v-model="dialog" max-width="500px">
    <AddCategory
      ref="AddCategory"
      @closeDialog="setFalse()"
      @reload="getcategory()"
      :id="categoryId"
      :viewType="viewType"
    />
  </v-dialog>
</template>

<script>
import AddCategory from "./AddCategory.vue";
import PrimeDataTable from "@/components/PrimeDataTable";
import categoryServis from "@/api/service/Category/CategoryService.js";
import commonService from "@/common.service";
export default {
  components: {
    AddCategory,
    PrimeDataTable,
  },
  data() {
    return {
      data: [],
      columns: [],
      date: new Date(),
      categoryId: "",
      dialog: false,
      viewType: false,
    };
  },
  created() {
    this.loadColumns();
    this.download = true;
    this.search = true;
    this.checkbox = true;
    this.getcategory();
  },
  methods: {
    //  Prime Data Table Data

    loadColumns() {
      this.columns = [
        {
          field: "code",
          header: "Code",
          style: { width: "100px", color: "" },
          toolTip: "Code",
          sortfield: true,
        },
        {
          field: "name",
          header: "Name",
          style: { width: "100px", color: "" },
          toolTip: "Name",
          sortfield: true,
        },
        {
          field: "modified",
          header: "Modified",
          style: { width: "100px", color: "" },
          toolTip: "Modified",
          sortfield: true,
        },
        {
          field: "active",
          header: "Status",
          style: { width: "100px", color: "" },
          toolTip: "Status",
          sortfield: true,
        },
        {
          field: "action",
          header: "Action",
          style: { width: "100px", color: "" },
          toolTip: "Action",
          sortfield: true,
          rowActions: [
            { action: "view" },
            { action: "edit" },
           
          ],
        },
      ];
    },

    setFalse() {
      this.dialog = false;
    },
    rowActions($event) {
      if ($event.type == "view") {
        this.dialog = true;
        this.categoryId = $event.data.id;
        this.viewType = $event.type;
      }
      if ($event.type == "edit") {
        this.dialog = true;
        this.categoryId = $event.data.id;
        this.viewType = $event.type;
      }

      if ($event.type == "select") {
        this.dialog = true;
        this.categoryId = $event.data.id;
        this.viewType = "view";
      }
    },

    // CategoryServis
    async getcategory() {
      let res = await categoryServis.findAll();
      this.data = res;
      console.log(this.data, "rrrr");
    },

    //Diolog

    addDiolog() {
      this.dialog = true;
      this.categoryId = null;
      this.viewType = false;
    },
    addFilter() {
      this.$refs.FilterDrawer.dialog = true;
      this.$refs.FilterDrawer.size = commonService.largeDialog();
    },
  },
};
</script>


